export function legacyAnthropicThinkingModelId(modelId: string): boolean {
  return modelId.toLowerCase().includes('thinking');
}
